export default __webpack_public_path__ + "static/media/plus.27a64c28.svg";